import { useEffect, useRef, useState } from "react";

const SearchableSelect = ({
  options,
  label,
  id,
  selectedVal,
  handleChange,
  sendValueToParent,
  isSearchable = true,
}) => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", toggle);
    return () => document.removeEventListener("click", toggle);
  }, []);

  const selectOption = (option) => {
    setQuery(() => "");
    handleChange(option[label]);
    setIsOpen((isOpen) => !isOpen);
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const getDisplayValue = () => {
    if (query) return query;
    if (selectedVal) return selectedVal;

    return "";
  };

  const filter = (options) => {
    if (options.length > 0) {
      return options.filter(
        (option) =>
          option[label] &&
          option[label].toLowerCase().indexOf(query.toLowerCase()) > -1
      );
    } else {
      return [];
    }
  };

  return (
    <div className="dropdown">
      <div className="control">
        <div className="selected-value">
          <input
            className="form-input"
            autoComplete="off"
            style={{ borderRadius: "6px !important" }}
            ref={inputRef}
            type="text"
            value={getDisplayValue()}
            name="searchTerm"
            onChange={(e) => {
              setQuery(e.target.value);
              if (sendValueToParent) {
                
                sendValueToParent(e.target.value);
              }
              handleChange(null);
            }}
            onClick={toggle}
          />
        </div>
        <div className={`arrow ${isOpen ? "open" : ""}`}></div>
      </div>

      <div className={`options ${isOpen ? "open" : ""}`}>
        {isSearchable ? (
          <>
            {filter(options).map((option, index) => {
              return (
                <div
                  onClick={() => selectOption(option)}
                  className={`option ${option[label] === selectedVal ? "selected" : ""
                    }`}
                  key={`${id}-${index}`}
                >
                  {option[label]}
                </div>
              );
            })}
          </>
        ) : (
          <>
            {options.map((option, index) => {
              return (
                <div
                  onClick={() => selectOption(option)}
                  className={`option ${option[label] === selectedVal ? "selected" : ""
                    }`}
                  key={`${id}-${index}`}
                >
                  {option[label]}
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

export default SearchableSelect;
